export const MAX_PER_COURSE = 2;

export const COURSES = [
  { key: "entrees", label: "Entrées" },
  { key: "mains", label: "Mains" },
  { key: "desserts", label: "Desserts" },
];

export const EMPTY_MENU = {
  package: "",
  entrees: [],
  mains: [],
  desserts: [],
  notes: "",
};

export const EMPTY_DRINKS = {
  package: "",
  sparkling: "",
  white: "",
  red: "",
  beer: "",
  non_alcoholic: "",
  notes: "",
};

const asList = (value) => (Array.isArray(value) ? value : []);
const asText = (value) => (Array.isArray(value) ? value.join(", ") : value || "");
const toList = (value) =>
  String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

export function menuFormFromDoc(doc = {}) {
  return {
    package: doc.package || "",
    entrees: asList(doc.entrees),
    mains: asList(doc.mains),
    desserts: asList(doc.desserts),
    notes: doc.notes || "",
  };
}

export function menuPayload(form) {
  return {
    package: form.package || "",
    entrees: asList(form.entrees),
    mains: asList(form.mains),
    desserts: asList(form.desserts),
    notes: form.notes || "",
  };
}

export function drinksFormFromDoc(doc = {}) {
  return {
    package: doc.package || "",
    sparkling: doc.sparkling || "",
    white: doc.white || "",
    red: doc.red || "",
    beer: asText(doc.beer),
    non_alcoholic: asText(doc.non_alcoholic),
    notes: doc.notes || "",
  };
}

export function drinksPayload(form) {
  return {
    package: form.package || "",
    sparkling: form.sparkling || "",
    white: form.white || "",
    red: form.red || "",
    beer: toList(form.beer),
    non_alcoholic: toList(form.non_alcoholic),
    notes: form.notes || "",
  };
}

export function groupCatalogue(items) {
  const grouped = { entrees: [], mains: [], desserts: [], drinks: [] };
  (items || []).forEach((item) => {
    if (grouped[item.category]) {
      grouped[item.category].push(item);
    }
  });
  return grouped;
}

export function itemNames(items, ids) {
  const byId = Object.fromEntries((items || []).map((item) => [item.item_id, item.name]));
  return asList(ids).map((id) => byId[id] || id);
}
